export enum WeatherSourceType {
    Manual = 0,
    Device = 1,
    WeatherApp = 2
}